module.exports = __webpack_public_path__ + "static/tablet2-bddcadb9066b0e69f3260eaa0f9c1f8d.png";